export function useBranchProducts(products = ref<any[]>([])) {
  const sortByRank = (element: any, nextElement: any) => element.rank - nextElement.rank
  const sortByOnboard = (element: any, nextElement: any) => (element.onboard <= nextElement.onboard ? 0 : -1)

  const branchProducts = computed(() => [...products.value].sort(sortByOnboard))

  const sortedBranchProducts = computed(() => [...products.value].sort(sortByRank).sort(sortByOnboard))

  const hasPureBooking = computed(() => products.value.some((product: any) => product.is_book_seat_only))
  const hasPayment = computed(() => products.value.some((product: any) => !product.is_book_seat_only))

  const pureBookingProducts = computed(() => products.value.filter((product: any) => product.is_book_seat_only))

  const isOnlyOnePureBooking = computed(() => pureBookingProducts.value.length === products.value.length && pureBookingProducts.value.length === 1)

  return {
    branchProducts,
    sortedBranchProducts,
    hasPureBooking,
    hasPayment,
    isOnlyOnePureBooking,
  }
}
